import { useContext as t } from "react";
import { a as n } from "./LinkDataProvider.js";
function i() {
  return t(n);
}
export {
  i as u
};
